import React, { Component } from 'react';
import './page.css';
//import MenuItem from './menu-item';
import AppIcon from './AppIcon';
// import Top from './top.js';
// import Bottom from './bottom.js';
import PageSummary from './PageSummary';
import { useRecoilState, useRecoilValue } from 'recoil';
import { isChildOpenAtom, isFolderOpenAtom, isFrostyAtom, openAppAtom } from '../recoil/isChildOpenAtom';

// import iconPhone from '../images/icons/1492509249_phone_ios7_ios_7.png';
// import iconCamera from '../images/icons/1492509273_camera_ios7_ios_7.png';
// import iconMusic from '../images/icons/1492509278_music_ios7_ios_7.png';
// import iconPhotos from '../images/icons/1492509282_photos_ios7_ios_7.png';
import iconMessages from '../images/icons/messages.ico';
import iconSettings from '../images/icons/1492509288_settings_ios7_ios_7.png';
import iconWeather from '../images/icons/1492509313_weather_ios7_ios_7.png';
import iconAppStore from '../images/icons/1492509283_app_store_ios7_ios_7.png';
import iconStocks from '../images/icons/1492509314_stocks_ios7_ios_7.png';
import iconClock from '../images/icons/1492509303_clock_ios7_ios_7.png';
import iconCalculator from '../images/icons/1492509301_calculator_ios7_ios_7.png';
import iconMaps from '../images/icons/1492509299_maps_ios7_ios_7.png';
import iconNotes from '../images/icons/1492509295_notes_ios7_ios_7.png';
import iconiTunes from '../images/icons/1492509293_itunes_ios7_ios_7.png';

import iconiMovie from '../images/icons/1492509294_videos_ios7_ios_7.png';
import iconReminders from '../images/icons/1492509318_reminders_ios7_ios_7.png';
import iconGameCenter from '../images/icons/1492509316_game_center_ios7_ios_7.png';
import iconNetflix from '../images/icons/netflix-2018-11-01.png';
import iconTwitter from '../images/icons/twitter-icon.png';
import iconWork from '../images/icons/work-icon.png';
import iconBlog from '../images/icons/wordpress-icon.jpg';

import iconPertino from '../images/icons/pertino.png';
import iconMeltwater from '../images/icons/meltwater.png';
import iconXMission from '../images/icons/xmission.png';
import iconVeracity from '../images/icons/veracity.jpg';
import iconVdr from '../images/icons/vdr.png';

import iconResEdit from '../images/icons/resedit.png';
import iconNagiosTV from '../images/icons/nagiostv.png';
import iconYummiYogurt from '../images/icons/yummiyogurt.png';
import iconSublimeSpot from '../images/icons/sublimespot.png';

import sublimespotScreenshot from '../images/sublimespot-screenshot.png';
import screenShotNagiosTV from '../images/nagiostv-screenshot.png';

import Folder from './Folder';


const PageGrid = ({ pagenumber }) => {

  // const [isFolderOpen, setIsFolderOpen] = useRecoilState(isFolderOpenAtom);

  // const onClickFrosty = () => {
  //   if (isFolderOpen) {
  //     setIsFolderOpen(false);
  //   }
  // };

  return (
    <div className="page-grid">

      {/* <div
        className={isFolderOpen ? 'folder-frosty frosty selected' : 'folder-frosty frosty'}
        onClick={onClickFrosty}
      /> */}

      {pagenumber === 1 && <>
        <AppIcon
            appName="Messages"
            item={1}
            pagenumber={pagenumber}
            icon={iconMessages}
        />
        <AppIcon
            appName="Weather"
            item={2}
            pagenumber={pagenumber}
            icon={iconWeather}
        />
        <AppIcon
            appName="Stocks"
            item={3}
            pagenumber={pagenumber}
            icon={iconStocks}
        />
        <AppIcon
            appName="Clock"
            item={4}
            pagenumber={pagenumber}
            icon={iconClock}
        />
        
        <AppIcon
            appName="Calculator"
            item={6}
            pagenumber={pagenumber}
            icon={iconCalculator}
        />
        <AppIcon
            appName="Maps"
            item={7}
            pagenumber={pagenumber}
            icon={iconMaps}
        />
        <AppIcon
            appName="App Store"
            item={8}
            pagenumber={pagenumber}
            icon={iconAppStore}
        />
        <AppIcon
            appName="Notes"
            item={8}
            pagenumber={pagenumber}
            icon={iconNotes}
        />
        
        

        
        

        <AppIcon
            appName="Settings"
            item={5}
            pagenumber={pagenumber}
            icon={iconSettings}
        />

        
        <AppIcon
            appName="YummiYogurt"
            pagenumber={pagenumber}
            icon={iconYummiYogurt}
            badge=""
            shortText={
              <div>
                WinAMP Skin<br />
                Created in 1999<br />
                Featured in WIRED Magazine Oct 2000<br />
                <br />
                <img src="https://chriscarey.com/blog/wp-content/uploads/2013/12/yummiyogurt2001xmms-275x372.gif" /><br />
                <a href="https://chriscarey.com/blog/design/skins/yummiyogurt/" target="_blank" rel="noreferer noopener">Link</a>
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
              </div>
            }
        />

        <AppIcon
            appName="SublimeSpot"
            pagenumber={pagenumber}
            icon={iconSublimeSpot}
            badge=""
            shortText={
              <div>
                A fan site for the band Sublime<br />
                Created in 1995<br />
                #1 result on Google for 10 years for search term "sublime"<br />
                <a href="https://sublimespot.com" target="_blank" rel="noreferer noopener">sublimespot.com</a>
                <br />
                <br />
                <img src={sublimespotScreenshot} style={{ margin: '0px 20px', width: 'calc(100% - 40px)', maxWidth: '500px' }} />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
              </div>
            }
        />

        <AppIcon
            appName="NagiosTV"
            pagenumber={pagenumber}
            icon={iconNagiosTV}
            badge=""
            shortText={
              <div>
                User interface for Nagios<br />
                Created in 2008<br />
                Actively maintained in 2021<br />
                Open Source on GitHub<br />
                <a href="https://nagiostv.com" target="_blank" rel="noreferer noopener">nagiostv.com</a>
                <br />
                <img src={screenShotNagiosTV} style={{ margin: '0px 20px', width: 'calc(100% - 40px)', maxWidth: '500px' }} />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
              </div>
            }
        />

        <AppIcon
            appName="Blog"
            pagenumber={pagenumber}
            icon={iconBlog}
            badge=""
        />


        {/** Work Folder */}
        <Folder
          name="Social Media"
          badge="1"
        >
          <AppIcon
            appName="Twitter"
            pagenumber={-2}
            icon={iconTwitter}
            badge="1"
          />
        </Folder>

        

       

        

        {/* <Folder
          name="Skins"
        >
          <AppIcon
              appName="WinAMP"
              pagenumber={-2}
              icon={iconYummiYogurt}
          />
          <AppIcon
              appName="GKrellM"
              pagenumber={-2}
              icon={iconYummiYogurt}
          />
        </Folder> */}

        

        {/** Work Folder */}
        <Folder
          name="Work"
          badge=""
        >
          <AppIcon
              appName="Netflix"
              pagenumber={-2}
              icon={iconNetflix}
              badge=""
              shortText={
                <div>
                  Senior Tools Engineer<br />
                  2014 - Current<br />
                  <br />
                  {/* Member of the Television Academy (Emmys) */}
                </div>
              }
          />
          <AppIcon
              appName="Pertino"
              pagenumber={-2}
              icon={iconPertino}
              shortText={
                <div>
                  Senior Software Engineer<br />
                  2012 - 2014
                </div>
              }
          />
          <AppIcon
            appName="Meltwater"
            pagenumber={-2}
            icon={iconMeltwater}
            shortText={
              <div>
                Senior Software Engineer<br />
                2011 - 2012
              </div>
            }
          />
          <AppIcon
            appName="XMission"
            pagenumber={-2}
            icon={iconXMission}
            shortText={
              <div>
                Senior Software Engineer<br />
                2008 - 2011
              </div>
            }
          />
          <AppIcon
            appName="Veracity"
            pagenumber={-2}
            icon={iconVeracity}
            shortText={
              <div>
                Software Engineer<br />
                2005 - 2008
              </div>
            }
          />
          <AppIcon
            appName="VDR"
            pagenumber={-2}
            icon={iconVdr}
            shortText={
              <div>
                Software Engineer<br />
                1996 - 1998, 2000 - 2004
              </div>
            }
          />
        </Folder>

        <AppIcon
            appName="About"
            item={8}
            pagenumber={pagenumber}
            icon={iconResEdit}
            badge=""
        />

      </>}

      {pagenumber === 2 && <>
        <AppIcon
            appName="iMovie"
            item={1}
            pagenumber={pagenumber}
            icon={iconiMovie}
        />
        <AppIcon
            appName="iTunes"
            item={8}
            pagenumber={pagenumber}
            icon={iconiTunes}
        />
        <AppIcon
            appName="Reminders"
            item={1}
            pagenumber={pagenumber}
            icon={iconReminders}
        />
        {/* <AppIcon
            appName="Netflix"
            item={2}
            pagenumber={pagenumber}
            icon={iconNetflix}
        /> */}


      </>}

      {pagenumber === 3 && <>
        
        <AppIcon
            appName="Game Center"
            item={1}
            pagenumber={pagenumber}
            icon={iconGameCenter}
        />
      </>}

    </div>
  );
};

const isEqual = () => { return true; }
const PageGridMemo = React.memo(PageGrid, isEqual);

const Page = ({
  pagenumber,
}) => {

  console.log(`Page ${pagenumber} render`);

  // state = {
  //     isChildOpen: false
  // };

  //const [isChildOpen, setIsChildOpen] = useRecoilState(isChildOpenAtom);
  const isChildOpen = useRecoilValue(isChildOpenAtom);

  //const [openApp, setOpenApp] = useRecoilState(openAppAtom);
  //const [isFrosty, setIsFrosty] = useRecoilState(isFrostyAtom);

  // const isChildOpen = (isChildOpen, childHandle) => {
  //   //console.log('isChildOpen() page ' + pagenumber + ' ');
  //   this.setState({
  //     isChildOpen,
  //     childHandle
  //   });
  //   setIsChildOpen();
  // };

  // const frostyClicked = () => {
  //     console.log(pagenumber + ' frosty clicked. close any menu items');
  //     // this.state.childHandle.setState({
  //     //     open: false
  //     // });
  //     setIsChildOpen(false);
  //     setIsFrosty(false);
  // };

  // const closeApp = (e) => {
  //   e.preventDefault();
  //   setIsChildOpen(false);
  //   setIsFrosty(false);    
  // };
  
  
  const landscapeMode = window.innerWidth > window.innerHeight;
  //const portraitMode = !landscapeMode;
  const iPadMode = false;

  //const frostyClass = isChildOpen ? 'frosty selected' : 'frosty';

  const showiPadWidgetArea = iPadMode && landscapeMode && pagenumber === 1;

  return (
    <div className={`page`} id={`page-${pagenumber}`}>

      {/* <div className={isChildOpen ? 'page-inner page-open' : 'page-inner'}> */}
      <div className={'page-inner'}>
      

        {/* <div
          className={frostyClass}
        /> */}

        {/* {isFrosty && <Top />}
        {isFrosty && <Bottom />} */}

        

        {showiPadWidgetArea && <div className="page-summary">
          <PageSummary />
        </div>}

        <div className={showiPadWidgetArea ? 'page-items page-items-scooch' : 'page-items'}>

          <PageGridMemo pagenumber={pagenumber} />
          

          {/* <div className="flex-grid">
            <div className="flex-grid-item">1</div>
            <div className="flex-grid-item">2</div>
            <div className="flex-grid-item">3</div>
            <div className="flex-grid-item">4</div>
            <div className="flex-grid-item">5</div>
            <div className="flex-grid-item">6</div>
            <div className="flex-grid-item">7</div>
            <div className="flex-grid-item">8</div>
            <div className="flex-grid-item">9</div>
          </div> */}

          
          {/* {pagenumber === 1 && <>
            <MenuItem
              appName="phone"
              item={1}
              pagenumber={pagenumber}
            />
            <MenuItem
              appName="camera"
              item={2}
              pagenumber={pagenumber}
            />
            <MenuItem item={3} pagenumber={pagenumber}  />
            <MenuItem item={4} pagenumber={pagenumber}  />
            <MenuItem item={5} pagenumber={pagenumber}  />
            <MenuItem item={6} pagenumber={pagenumber}  />
            <MenuItem item={7} pagenumber={pagenumber}  />
            <MenuItem item={8} pagenumber={pagenumber}  />
          </>}

          {pagenumber === 2 && <div>
            <MenuItem item={1} pagenumber={pagenumber}  />
            <MenuItem item={2} pagenumber={pagenumber}  />
            <MenuItem item={3} pagenumber={pagenumber}  />
          </div>}
          
          {pagenumber === 3 && <div>
            <MenuItem item={1} pagenumber={pagenumber}  />
          </div>} */}
          

        </div>
      </div>
      
      



      
    </div>
  );
  
};

export default React.memo(Page);
